//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getUserInfo from '@/common/utils/getUserInfo'
import PublicService from '@/service/public'
import SubscribeTip from '../_components/_subscribe_tip'

export default {
    components: {
        SubscribeTip
    },
    props: {
        building_id: [Number, String],
        name: String,
        page: String,
        layout_id: [Number, String],
        favourite: Boolean,
        building: Object,
        add_group_url: String
    },
    computed:{
        force_phone_auth(){
            return this.building && this.building.activities && this.building.activities.indexOf('授权手机号') > -1
        }
    },
    created () {
    },
    methods: {
        goConsultant () {
            console.log(111);
            wx.navigateTo({
                url: `/consultants/filter/main?id=${this.building_id}&from=${this.page||''}&layout_id=${this.layout_id||''}`
            })
        },
        goCall () {
            this.$showCallModal(this.getPhoneCall, `${this.page}-底部免费电话咨询点击`)
        },
        getPhoneCall () {
            PublicService.getPhonePosition({
                building_id: this.building_id
            }).then(({ phone }) => {
                wx.makePhoneCall({
                    phoneNumber: phone,
                    success: () => {}
                })
            })
        },
        toggleFavourite () {
            if (!this.favourite) {
                this.$sendCtmEvtLog('订阅楼盘')
            }
            PublicService.follow('Fc::Building', this.building_id, !this.favourite)
            this.$emit('toggleFavourite')
        }
    }
}
